<script setup lang="ts">

import { FeatureType } from '@domain/CarePlan/WorkOrders/FeatureType';
import type { IWorkOrderConfigurationDto } from '@domain/CarePlan/WorkOrders/IWorkOrderConfiguration';

type Props = {
    item?: IWorkOrderConfigurationDto,
}

const { item } = defineProps<Props>();

const total = item == null ? 0
    : item.hasAnnualClaimLimit ? item.maximumAnnualClaimCount 
    : item.maximumClaimCount;
    
const used = item == null ? 0
    : item.hasAnnualClaimLimit ? item.annualClaimCount
    : item.claimCount

</script>

<template>

    <div class="
        flex flex-col items-center justify-center
        ">

        <div class="p-4 2xl:p-6 flex flex-col gap-4 2xl:gap-6 items-center
                 text-base 2xl:text-xl">

            <!-- <div v-if="item != null"
                class="flex flex-col items-center gap-2 2xl:gap-4">
                <div class="px-8">
                    <img v-if="item.product == FeatureType.Protect" src="@/assets/images/protect-logo.png" class="w-full" />
                    <img v-else-if="item.product == FeatureType.Rewards" src="@/assets/images/rewards-logo.png" class="w-full"/>
                </div>
            </div> -->

            <slot />

            <template v-if="item != null">
                <div v-if="item.hasAnnualClaimLimit && item.hasReachedAnnualClaimLimit"
                    class="
                        text-white/60 shadow-1 w-full
                        flex flex-col items-center ">
                    <div class="text-sm 2xl:text-base text-center">
                        You've reached your annual work limit on this item,
                        <br/>
                        but you can still call us to book a repair
                    </div>
                </div>

                <div v-else-if="item.isClaimable == false"
                    class="
                        text-white/60 shadow-1 w-full
                        flex flex-col items-center">
                    <div class="text-sm 2xl:text-base text-center">
                        You're at the limit of your available orders,
                        <br/>
                        but you can still call us to book a repair
                    </div>
                </div>

                <div v-else
                    class="
                    text-white/60 shadow-1 w-full
                        flex flex-col items-center">
                    <div class="text-sm 2xl:text-base text-center">
                        You've used {{ used }} of your {{ total }} available orders
                    </div>
                </div>
            </template>

        </div>

    </div>


</template>